// Copyright 2022, Imprivata, Inc.  All rights reserved.

const LINK_ID_PATTERN = /^[A-Za-z0-9_-]{22,64}$/;

/**
 * Reads the service desk link ID from a URL fragment such as `#l=<linkId>`.
 * The link ID is kept in the fragment so it never reaches server logs or Referer headers.
 * @param hash - The URL fragment, e.g. `window.location.hash`
 * @returns The link ID, or undefined when it is missing or not 22 to 64 base64url characters
 */
export const parseLinkId = (hash: string): string | undefined => {
  const linkId = new URLSearchParams(hash.replace(/^#/, '')).get('l');
  return linkId !== null && LINK_ID_PATTERN.test(linkId) ? linkId : undefined;
};
